<template>
  <el-dialog title="修改下单金额" :visible.sync="visibleDialog" width="920px" top="calc(50vh - 220px)" class="pop-dialog pop-goods-amount" append-to-body>
    <div class="goods-con" v-loading="loading">
      <el-table :data="tableData.items" height="300px">
        <el-table-column label="商品">
          <template slot-scope="scope">
            <div class="goods-info">
              <div class="img">
                <el-image :src="scope.row.goodsSkuPic" class="pic" fit="cover">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </div>
              <div class="con">
                <div class="name">{{ scope.row.goodsName }}</div>
                <div class="text">{{ scope.row.goodsSkuName }}</div>
                <div class="text">体积：{{ scope.row.volume}}<span class="space"></span>重量：{{ scope.row.weight}}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="编号" width="220">
          <template slot-scope="scope">
            <div class="name">{{ scope.row.wyGoodsCode || '缺失' }}</div>
            <div class="text">外部编号：{{ scope.row.outGoodsCode || '缺失' }}</div>
          </template>
        </el-table-column>
        <el-table-column label="单价/数量" width="200">
          <template slot-scope="scope">
            <div class="row ">
              <div class="label">零售价:</div>
              <el-input placeholder="请输入" v-model="scope.row.goodsPrice" size="mini" class="input" @input="changeTotal">
                <template slot="prepend">￥</template>
              </el-input>
            </div>
            <div class="row row-top">
              <div class="label">数<span class="space"></span>量:</div>
              <el-input-number v-model="scope.row.quantity" :min="1"  size="mini"  class="input" @change="changeTotal"></el-input-number>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="小计" width="120">
          <template slot-scope="scope">
            <div class="total-cell">
              <div class="name">支付￥{{ sum(scope.row.goodsPrice,scope.row.quantity) }}</div>
              <div class="name">￥{{ sum(scope.row.marketPrice,scope.row.quantity) }}</div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="total-con">
        总计：共{{ totalNum }}件<span class="space"></span>
        商品总价：￥{{  totalAmount }}<span class="space"></span>
        运费：￥{{ tableData.totalFreightAmount}}<span class="space"></span>
        应付：
        <el-input placeholder="请输入" v-model.number="payAmount" size="mini"  class="input">
          <template slot="prepend">￥</template>
        </el-input><span class="space"></span>
        已收：
        <div class="input-group">
          <el-input placeholder="请输入" v-model.number="hasPay" size="mini"  class="input">
            <template slot="prepend">￥</template>
          </el-input>
          <div class="error">{{ errorInfo }}</div>
        </div>
      </div>
    </div>
    <template slot="footer">
      <el-button @click="visibleDialog = false" size="mini">取 消</el-button>
      <el-button type="primary" @click="onConfirm" size="mini" :loading="btnLoading">确 定</el-button>
    </template>
  </el-dialog>
</template>
<script>

export default {
  name: 'popGoodsAmount',
  data() {
    return {
      visibleDialog: false,
       tableData: {
         items:[]
      },
      loading: false,
      btnLoading:false,
      type: '',
      orderNo:'',
      payAmount:'', // 应付金额
      hasPay: '', // 已收金额
      errorInfo:'',
    }
  },
  computed: {
    // 商品个数
    totalNum() {
      if (!Array.isArray(this.tableData.items) || this.tableData.items.length === 0) {
        return 0
      }
      return this.tableData.items.reduce((total, item) => {
        return total + Number(item.quantity || 0)
      }, 0)
    },
    // 商品总价
    totalAmount() {
      if (!Array.isArray(this.tableData.items) || this.tableData.items.length === 0) {
        return 0
      }
      return this.tableData.items.reduce((total, item) => {
        return total + Number((Number(item.quantity || 0) * Number(item.marketPrice || 0)).toFixed(2))
      }, 0)
    },
  },
  watch: {
    hasPay(newValue, oldValue) {
      if (newValue>this.payAmount) {
        this.errorInfo = '已收金额不能大于应付金额'
        return
      }else{
        this.errorInfo = ''
      }
    }
  },
  methods: {
    show(data) {
      this.type = data.type || ''
      this.orderNo = data.orderNo
      this.tableData = {
        items:[]
      }
      console.log('show:', data)
      if(this.orderNo){
        this.fetchData()
      }
      this.visibleDialog = true
    },
    // 修改下单金额
    onConfirm() { 
      this.btnLoading = true
      let items = this.tableData.items.map(e=>({
        wuyuSku:e.wuyuSku,
        retailPrice:e.goodsPrice,
        quantity:e.quantity,
      }))
      const postData = {
        orderNo: this.orderNo,
        payableAmount: this.payAmount,
        paidAmount: this.hasPay,
        items: items
      }
      this.$api.omsOrderItemUpdate(postData).then(res => { 
        if (res.code == 0) { 
          this.$message.success('修改成功')
          this.$emit('fetchData')
          this.visibleDialog = false
        }
      }).finally(() => { 
        this.btnLoading = false
      })
    },
    fetchData() {
      this.loading = true
      this.$api.omsOrderItem(this.orderNo).then(res => {
        if (res.code == 0) { 
          this.tableData = res.data
          
          // this.totalAmount = this.tableData.totalGoodsAmount // 商品总价
          this.payAmount = this.tableData.receivableAmount // 商品应付金额

          this.hasPay = this.tableData.paidAmount // 已收金额

        }
      }).finally(() => { 
        this.loading = false
      })
    },
    // 小计
    sum(price, num){
      return (price * num).toFixed(2)
    },
    // 修改应付金额
    changeTotal() { 
      if (!Array.isArray(this.tableData.items) || this.tableData.items.length === 0) {
        return '0.00'
      }
      const total = this.tableData.items.reduce((sum, item) => {
        const price = Number(item.goodsPrice || 0)
        const num = Number(item.quantity || 0)
        return sum + Number((price * num).toFixed(2))
      }, 0)
      console.log('>>',total)
      this.payAmount = total
    },
  },
}
</script>

<style lang='scss'>
.pop-goods-amount {
   .space{
      display: inline-block;
      width: 20px;
    }
  .goods-con {
    padding: 10px 0 0 0;
    .input{
      width: 100px;
      .el-input-group__prepend{
        padding: 0;
        text-align: center;
        width: 28px;
      }
      .el-input__inner{
        padding: 0 0 0 6px;
      }
    }
    .row{
      display:flex;
      align-items: center;
      
      .label{
        display: inline-block;
        width: 50px;
        .space{
          width: 12px;
        }
      }
    }
    .row-top{
      padding-top: 6px;
    }
    .total-cell{
      text-align: right;
    }
    .goods-info{
      display: flex;
      .img{
        margin-right: 12px;
        width: 40px;
        height: 40px;
        flex-shrink: 0;
         .el-image{
          text-align: center;
          line-height: 1;
          font-size: 16px;
          color: #bcbcbc;
          margin: 0 auto;
          width: 38px;
          height: 38px;
           .image-slot{
            line-height: 38px;
          }
          .el-image__placeholder{
            display: none;
          }
        }
        .pic{
          width: 40px;
          height: 40px;
        }
      }
      .space-top{
        padding-top: 4px;
      }
      
    }
    .hand{
      cursor: pointer;
    }
    .name{
      color: #333;
    }
    .text{
      color: #7F7F7F;
    }
    
    .el-table{
      border-top: 1px solid #E3E3E3;
      tbody{
        border-left: 1px solid #E3E3E3;
        border-right: 1px solid #E3E3E3;
      }
      // border-bottom: none;
       .el-table__body-wrapper{
        scrollbar-width: thin;
       }
    }
    .el-table th.el-table__cell {
      padding: 0;
      height: 28px;
      line-height: 28px;
      font-weight: normal;
      background-color: #F8F8F8;

      .cell {
        font-size: 12px;
        font-weight: normal;
        padding-left: 12px;
        color: #7F7F7F;
      }
    }

    .el-table td.el-table__cell {
      padding: 0;
      padding: 6px 0 8px;

      .cell {
        font-size: 12px;
        padding-left: 12px;
        line-height: 18px;
      }


    }
    .el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell{
      background: #E3F0FC;
    }
  }

  .total-con {
    height: 57px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .total-price {
      display: inline-block;
      width: 80px;
      text-align: left;
      box-sizing: border-box;
      padding-left: 12px;
    }
    .total-number{
      display: inline-block;
      width: 80px;
      text-align: left;
      box-sizing: border-box;
      padding-left: 12px;
    }
    .input-group{
      position: relative;
      .error{
        position: absolute;
        right: 0;
        top: 30px;
        white-space: nowrap; 
        color: red;
        font-size: 12px;
      }
    }
  }

}
</style>